import $ from 'jquery';
import Swiper from 'swiper';
import QuickAdd from '../global/QuickAdd';
import Section from '../Section';

function get_unique_array(array) {
  var newArray = new Array();
  var handleArray = new Array();

  for (var i = 0; i < array.length; i++) {
    var handle = array[i]['handle'];
    if (handleArray.indexOf(handle) === -1) {
      newArray.push(array[i]);
      handleArray.push(handle);
    }
  }
  return newArray;
}

export default class RecentlyViewed extends Section {
  RECENTLY_VIEWED_COUNT = 10;
  RECENTLY_VIEWED_LOCAL_STORAGE_KEY = 'recentlyVisited';
  PLACEHOLDER = 'PLACEHOLDER';

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.$element = $(element);
    this.handle = this.element.dataset.productHandle;
    this.productUrl = this.element.dataset.productUrl;
    this.blocksArray = this.element.dataset.blocks.split(',');
    this.$content = this.$element.find('#recently-viewed-products');
    this.quickShopDesktopEnabled = this.element.dataset.quickShopDesktopEnabled;
    this.quickShopMobileDisabled = this.element.dataset.quickShopMobileDisabled;

    var self = this;
    window.addEventListener('load', (event) => {
      setTimeout(() => {
        if(self.swiper) {
          self.swiper.resize.resizeHandler();
        }
      }, 1000);
    });

    if (this.$content.hasClass('recently-viewed-loading')) {
      return;
    }

    this.$content.empty().addClass('recently-viewed-loading');

    var recentlyViewedJSON = null;

    if (this._isLocalStorageSupported()) {
      recentlyViewedJSON = localStorage.getItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY);
    }

    var recentlyViewed = recentlyViewedJSON != null ? JSON.parse(recentlyViewedJSON) : [];

    if (this.handle) {
      var item = {
        'handle': this.handle,
      };
      recentlyViewed.unshift(item);
    }

    var uniqueArray = recentlyViewed.length ? get_unique_array(recentlyViewed) : recentlyViewed;
    if (uniqueArray.length > this.RECENTLY_VIEWED_COUNT) {
      uniqueArray = uniqueArray.slice(0, this.RECENTLY_VIEWED_COUNT);
    }

    if (this._isLocalStorageSupported()) {
      localStorage.setItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY, JSON.stringify(uniqueArray));
    }

    if (uniqueArray.length > 1 || (uniqueArray.length === 1 && uniqueArray[0]['handle'] !== this.handle)) {
      this.loadProducts(uniqueArray.filter((item) => { return item.handle !== this.handle }));
    } else {
      this.$element.remove();
    }
  }

  loadProducts = (recentlyViewed) => {
    let str = this.paramStr(this.blocksArray);

    var promises = recentlyViewed.map(function (rv) {
      return $.get(this.productUrl.replace(this.PLACEHOLDER, rv.handle), { blocks: str });
    }.bind(this));

    $.when.apply($, promises)
      .then(() => {
        let allOK = true;

        promises.forEach((promise) => {
          if (promise.status === 200) {
            var container = document.createElement('div');
            container.innerHTML = promise.responseText;

            this.$content.append(
              container.querySelector('.main-content .grid__item').outerHTML
            );

            this.$content.find('.grid__item').addClass('swiper-slide');
            this.orderBlocks(container.querySelector('.grid-view-item'));

          } else {
            console.warn('Unable to fetch recently visited product: ', promise.status, promise.responseText);
            allOK = false;
          }
        });

        if (allOK) {
          this.show();
        }
        else {
          this.hideButtons();
        }
      });
  }

  orderBlocks = (parent) => {
    if(!this.blocksArray) return;

    const clone = parent.cloneNode(true);
    parent.innerHTML = '';

    this.blocksArray.forEach((block) => {
      if (!block) return;
      const blockElement = clone.querySelector(`[data-block-type=${block}]`);
      if (blockElement) {
        parent.appendChild(blockElement);
      }
    });
  }

  hideButtons = () => {
    this.$element.find('.swiper-button--next').hide();
    this.$element.find('.swiper-button--prev').hide();
  }

  show = () => {
    const nextEl = this.element.querySelector('.swiper-button--next');
    const prevEl = this.element.querySelector('.swiper-button--prev');
    this.$element.fadeIn();
    this.swiper = new Swiper(this.element.querySelector('.swiper-container'), {
      slidesPerView: 2,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
      watchOverflow: true,
      autoHeight: true,
    });

    this.loadShopNow();
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
    this.badge = this.theme.addBadges(this.element, 1000);

    const sectionLoadedEvent = new CustomEvent('theme:section:load');
    document.dispatchEvent(sectionLoadedEvent);
  }

  loadShopNow = () => {
    if (this.quickShopDesktopEnabled === 'true') {
      Array.prototype.forEach.call(
        this.element.querySelectorAll('.grid-view-item'),
        (el) => {
          const productId = Number(el.dataset.productId);
          const productAvailable = (el.dataset.productAvailable == 'true');
          const productVarSize = Number(el.dataset.productVariantsSize);
          const product_url = el.dataset.productUrl;
          const cardImageBottomWrapper = el.querySelector('.product-card-image--bottom-wrapper');

          // Construct button for this product.
          const a_desktop = document.createElement('a');
          const a_mobile = document.createElement('a');
          const wrapper = document.createElement('div');
          wrapper.classList.add('quick-add-wrapper');
          if(productVarSize == 1) wrapper.classList.add('is-singular');

          if(productVarSize > 1 && productAvailable) {
            // Desktop button.
            a_desktop.classList.add('btn', 'quick-add-button-variants', 'quick-add-button-variants-desktop');
            a_desktop.tabIndex = 0;
            a_desktop.href = product_url;
            a_desktop.textContent = this.theme.translations.view_options;

            // Mobile button.
            a_mobile.classList.add('quick-add-button-variants', 'quick-add-button-variants-mobile', 'icon-btn-focus-inner', 'btn-hover-default-inner');
            if (this.quickShopMobileDisabled == 'true') a_mobile.classList.add('quick-shop-hidden');

            a_mobile.tabIndex = 0;
            a_mobile.href = product_url;

            const icon_span = document.createElement('span');
            icon_span.classList.add('btn-colors-primary', 'round-icon-btn-sm');
            icon_span.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="quick-view-mobile-icon"><path d="M11.6673 4.16667C11.6673 3.72464 11.4917 3.30072 11.1791 2.98816C10.8665 2.67559 10.4426 2.5 10.0006 2.5C9.55856 2.5 9.13464 2.67559 8.82208 2.98816C8.50952 3.30072 8.33392 3.72464 8.33392 4.16667M16.0506 8.08L17.2048 15.58C17.2413 15.8174 17.226 16.0598 17.1601 16.2908C17.0942 16.5217 16.9791 16.7357 16.8228 16.918C16.6665 17.1004 16.4727 17.2468 16.2545 17.3472C16.0364 17.4477 15.7991 17.4998 15.5589 17.5H4.44226C4.20195 17.5 3.96448 17.4481 3.74613 17.3477C3.52777 17.2474 3.3337 17.101 3.17721 16.9187C3.02072 16.7363 2.90552 16.5222 2.83951 16.2912C2.7735 16.0601 2.75823 15.8175 2.79476 15.58L3.94892 8.08C4.00947 7.68633 4.20899 7.32735 4.51136 7.06809C4.81373 6.80882 5.19895 6.66642 5.59726 6.66667H14.4039C14.8021 6.66662 15.1871 6.80911 15.4893 7.06836C15.7915 7.3276 15.9901 7.68647 16.0506 8.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            a_mobile.appendChild(icon_span);

            [a_desktop, a_mobile].forEach((a) => {
              wrapper.appendChild(a);
            });
          }
          else if(productAvailable) {
            // HTML Form. Used for the 'Add to cart' button functionality.
            const form = document.createElement('form');
            form.method = 'post';
            form.action = '/cart/add';
            form.id = 'CollectionAddToCartForm';
            form.acceptCharset = 'UTF-8';
            form.classList.add('shopify-product-form');
            form.enctype = 'multipart/form-data';
            // Hidden form inputs.
            const form_type = document.createElement('input');
            form_type.type = 'hidden';
            form_type.name = 'form_type';
            form_type.value = 'product';
            form.appendChild(form_type);
            const utf_input = document.createElement('input');
            utf_input.type = 'hidden';
            utf_input.name = 'utf8';
            utf_input.value = '✓';
            form.appendChild(utf_input);
            const prod_id = document.createElement('input');
            prod_id.type = 'hidden';
            prod_id.name = 'id';
            prod_id.value = productId.toString();
            form.appendChild(prod_id);

            // Submit button desktop.
            const btn_desktop = document.createElement('button');
            btn_desktop.classList.add('btn', 'quick-add-button', 'quick-add-button-desktop');
            btn_desktop.type = 'submit';
            btn_desktop.tabIndex = 0;
            btn_desktop.textContent = this.theme.translations.addToCart;

            // Submit button mobile.
            const btn_mobile = document.createElement('button');
            btn_mobile.classList.add('quick-add-button', 'quick-add-button-mobile', 'icon-btn-focus-inner', 'btn-hover-default-inner');
            if (this.quickShopMobileDisabled == 'true') btn_mobile.classList.add('quick-shop-hidden');

            btn_mobile.type = 'submit';
            btn_mobile.tabIndex = 0;

            const icon_span = document.createElement('span');
            icon_span.classList.add('btn-colors-primary', 'round-icon-btn-sm');
            icon_span.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="quick-view-mobile-icon"><path d="M11.6673 4.16667C11.6673 3.72464 11.4917 3.30072 11.1791 2.98816C10.8665 2.67559 10.4426 2.5 10.0006 2.5C9.55856 2.5 9.13464 2.67559 8.82208 2.98816C8.50952 3.30072 8.33392 3.72464 8.33392 4.16667M16.0506 8.08L17.2048 15.58C17.2413 15.8174 17.226 16.0598 17.1601 16.2908C17.0942 16.5217 16.9791 16.7357 16.8228 16.918C16.6665 17.1004 16.4727 17.2468 16.2545 17.3472C16.0364 17.4477 15.7991 17.4998 15.5589 17.5H4.44226C4.20195 17.5 3.96448 17.4481 3.74613 17.3477C3.52777 17.2474 3.3337 17.101 3.17721 16.9187C3.02072 16.7363 2.90552 16.5222 2.83951 16.2912C2.7735 16.0601 2.75823 15.8175 2.79476 15.58L3.94892 8.08C4.00947 7.68633 4.20899 7.32735 4.51136 7.06809C4.81373 6.80882 5.19895 6.66642 5.59726 6.66667H14.4039C14.8021 6.66662 15.1871 6.80911 15.4893 7.06836C15.7915 7.3276 15.9901 7.68647 16.0506 8.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            btn_mobile.appendChild(icon_span);

            [btn_desktop, btn_mobile].forEach((btn) => {
              form.appendChild(btn);
            });

            wrapper.appendChild(form);
          }
          else {
            // Desktop button.
            a_desktop.classList.add('btn', 'sold-out-button', 'sold-out-button-desktop', 'disabled');
            a_desktop.href = product_url;
            a_desktop.tabIndex = -1;
            a_desktop.textContent = this.theme.translations.soldOut;

            // Mobile button.
            a_mobile.classList.add('sold-out-button', 'sold-out-button-mobile', 'icon-btn-focus-inner-muted');
            if (this.quickShopMobileDisabled == 'true') a_mobile.classList.add('quick-shop-hidden');
            a_mobile.href = product_url;

            const icon_span = document.createElement('span');
            icon_span.classList.add('round-icon-btn-sm');
            icon_span.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="quick-view-mobile-icon"><path d="M11.6673 4.16667C11.6673 3.72464 11.4917 3.30072 11.1791 2.98816C10.8665 2.67559 10.4426 2.5 10.0006 2.5C9.55856 2.5 9.13464 2.67559 8.82208 2.98816C8.50952 3.30072 8.33392 3.72464 8.33392 4.16667M16.0506 8.08L17.2048 15.58C17.2413 15.8174 17.226 16.0598 17.1601 16.2908C17.0942 16.5217 16.9791 16.7357 16.8228 16.918C16.6665 17.1004 16.4727 17.2468 16.2545 17.3472C16.0364 17.4477 15.7991 17.4998 15.5589 17.5H4.44226C4.20195 17.5 3.96448 17.4481 3.74613 17.3477C3.52777 17.2474 3.3337 17.101 3.17721 16.9187C3.02072 16.7363 2.90552 16.5222 2.83951 16.2912C2.7735 16.0601 2.75823 15.8175 2.79476 15.58L3.94892 8.08C4.00947 7.68633 4.20899 7.32735 4.51136 7.06809C4.81373 6.80882 5.19895 6.66642 5.59726 6.66667H14.4039C14.8021 6.66662 15.1871 6.80911 15.4893 7.06836C15.7915 7.3276 15.9901 7.68647 16.0506 8.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            a_mobile.appendChild(icon_span);

            [a_desktop, a_mobile].forEach((a) => {
              wrapper.appendChild(a);
            });
          }

          if (cardImageBottomWrapper) cardImageBottomWrapper.appendChild(wrapper);
        }
      )
    }

    const quickAddButtons = this.element.querySelectorAll('.quick-add-button-variants')
    quickAddButtons.forEach((button) => {
      button.addEventListener('click', this.handleShopNow.bind(this));
    });
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.currentTarget.href });
  }

  _isLocalStorageSupported = () => {
    try {
      return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
    } catch (e) {
      return false;
    }
  }

  paramStr = (arr) => {
    var parameters = [];
    for (var property in arr) {
      if (Object.prototype.hasOwnProperty.call(arr, property) && arr[property].length > 0) {
        parameters.push(encodeURI(arr[property]));
      }
    }

    return parameters.join(',');
  }

  // check if we're on mobile
  isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
}
